export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="overline-label mb-3">Oxford, Mississippi</div>
      <h1 className="font-serif text-5xl lg:text-7xl font-light">About Scott Burton</h1>
      <div className="mt-10 space-y-6 text-neutral-300 leading-relaxed text-lg font-light">
        <p>
          At age 11, Scott Burton discovered his calling behind a camera, capturing the electric
          atmosphere of Las Vegas events alongside his father. Those early moments — filled with
          shared purpose and creativity — ignited a passion that would define his life.
        </p>
        <p>
          At Ole Miss, Scott honed his craft as the university's athletic photographer, laying the
          groundwork for a remarkable 20-year career as a photojournalist. His powerful images,
          published in <span className="text-amber-glow">Sports Illustrated</span>,
          <span className="text-amber-glow"> Newsweek</span> and
          <span className="text-amber-glow"> ESPN</span>, froze the thrill of sport in time — while
          his lens also immortalized over 1,000 weddings worldwide, each frame brimming with love and artistry.
        </p>
        <p>
          Today, Scott shares this cherished legacy with his son, William, passing down the same
          soulful, intuitive approach he learned from his own father. Using long lenses to discreetly
          seize once-in-a-lifetime moments, every photograph tells a story — a thread woven through
          generations of devotion to capturing life's most unforgettable scenes.
        </p>
      </div>
      <div className="mt-14 grid grid-cols-3 gap-6 border-t border-white/10 pt-10">
        {[["Weddings captured", "1,000+"], ["Years behind the lens", "20"], ["Published in", "SI · ESPN"]].map(([l, v]) => (
          <div key={l}>
            <div className="font-serif text-4xl text-amber-glow">{v}</div>
            <div className="overline-label mt-1">{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
